import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import FormHeader from '../form-header/form-header';
import IconBtn from '../../../../modules/icon-btn/icon-btn';

import '../../../../modules/authorization/alert/alert.scss';
import '../../../key-storage/index.scss';
import { getCompanyInfo } from '../../../../store/actions/company-info';
import { SIGNUP_PATHS } from '../../../../constants';
import { useAppDispatch } from '../../../../store';

const KeyGenerationResultStep: FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const goToMain = () => {
    dispatch(getCompanyInfo()).then((res) => {
      let payload = res.payload as {
        status: 'VERIFIED' | 'NON_VERIFIED' | 'NEED_KEY_GENERATION';
      };
      if (payload.status === 'VERIFIED') {
        history.push('/');
      } else if (payload.status === 'NEED_KEY_GENERATION') {
        history.push(SIGNUP_PATHS.KEY_GENERATION);
      } else {
        history.push(SIGNUP_PATHS.VERIFICATION);
      }
    });
  };

  return (
    <form className="login-form login-form--6">
      <FormHeader bigTitle="Генерация Ключа" />
      <div className="login-form__fildset">
        <h2 className="text-1 login-form__fildset-title ">
          Поздравляем, Ключ успешно создан!
        </h2>
        <div className="key-form__container">
          <div className="login-form__item-input--sm">
            <p className="p">
              Теперь вы можете пользоваться платформой. Ключ потребуется
              <br /> при операциях купли-продажи, обмена или выпуска токенов.
            </p>
          </div>
          <br />
          <div className="login-form__footer">
            <div className="login-form__actions">
              <IconBtn
                lg
                title="Приступить к работе с платформой"
                onClick={goToMain}
              />
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default KeyGenerationResultStep;
